// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    AUTHOR_PAGE_LOADING() {
      return {
        isLoading: true,
        authorPage: action.authorPage
      };
    },
    AUTHOR_PAGE_LOADED() {
      const currentState = store.getState();
      const authorData = get(currentState, 'author.data');
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        authorData,
        'authorPage'
      );

      return {
        isLoading: false,
        data: action.authorPage,
        ads: adModelData
      };
    },
    AUTHOR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.authorPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
